<template>
    <div class="main">
        <div v-if="list && list!=''" class="model-box bcw ptn">
            <div class="model-box__bd fs2 c6 mtm clear">
              <van-list v-model="listLoading" :finished="listFinished" @load="onLoadMore" loading-text="努力加载中...">
                <reserved-card v-for="(item,index) in list" :key="index" :item="item"></reserved-card> 
              </van-list>               
            </div>
        </div>
        <div v-else class="tac norecord">
            <i class="iconfont">&#xe646;</i><br/>
            暂无记录
        </div>
        <div class="clear bcw buybar">
          <div class="buybar__content clear">
            <router-link v-if="this.$route.params.type == 'clubPracticeCard'" :to="{name: 'mycardlist',params:{clubId:clubId,cardType:'DAYS_CARD'}}">
                <van-button type="primary" size="large" class="fs3">新的预约</van-button>
            </router-link>
            <router-link v-if="this.$route.params.type == 'clubPtCourse'" :to="{name: 'mycourselist',params:{clubId:clubId}}">
                <van-button type="primary" size="large" class="fs3">新的预约</van-button>
            </router-link>
          </div>
        </div>
        
    </div>    
</template>
<script>
import Vue from 'vue';
import { Button,List } from 'vant';
import MyCycleCard from '@/components/MyCycleCard';
import ReservedCard from '@/components/ReservedCard';
Vue.use(Button).use(List);

export default {
    name: 'MyReserved',
    components: {
        MyCycleCard,ReservedCard
    },
    data(){
      return {
        list:[],//约课列表
        type:"DAYS_CARD",
        clubId: this.$route.params.clubId,
        listLoading: false,
        listFinished: false,
        page: 1,
        pageSize: 15
      }
    },
    created(){
        this.getList();
    },
    methods:{
        onLoadMore() {
            // console.log('加载更多'); 
            this.page++ 
            this.getList();   
        },
        getList(){
            let _this = this
            // 取我的练球卡数据
            // console.log('进入page',_this.page)
            this.$http.post('club_user_reserve/getList',{
                type:_this.$route.params.type,
                page:_this.page,
                limit:_this.pageSize
            }).then(function(res){
                if(!res.data.code){ 
                    let re = res.data.value               
                    _this.list = _this.list.concat(re.data)

                    _this.listLoading = false;
                    if (re.data.length < _this.pageSize) {
                        _this.listFinished = true;
                    }
                    if(!_this.clubId){
                        _this.clubId = _this.list[0].clubId  //赋值 防止分享页面直接登录获取不到session的CLUBID
                    }                     
                    // console.log('最终page',_this.page)              
                }else{
                    _this.listFinished = true;
                }
            })
        }
    }

}
</script>
<style lang="less" scoped>
.cycleitem{
    margin: 0 .15rem;
}
.appointment-card{ 
    position: relative;
    height: .8rem;
    padding:.1rem; 
    font-size: .16rem; 
    background-color: #fff; 
    border-bottom: 1px solid #ccc; 
    color: #444;
    z-index: 1;
    &-body{
        z-index: 1;
        &__status{
            &--success{ 
                color: #68c864;
            }
        }
    }
    &-footer{
        position: absolute;
        
    }
}
.model-box{
    &__hd{
        margin: -0.05rem 0 0 -0.15rem;
        display: inline-block;
        padding: .05rem .1rem;
        background: #c3c3c3;
        color: #fff;
        border-top-right-radius: 1rem;
        border-bottom-right-radius: 1rem;
    }
}


@supports (bottom: constant(safe-area-inset-bottom)) or (bottom: env(safe-area-inset-bottom)) {
  .buybar {
    padding-bottom: constant(safe-area-inset-bottom);
    padding-bottom: env(safe-area-inset-bottom);
  }
}
</style>



// WEBPACK FOOTER //
// src/pages/MyReserved.vue